import Select from "react-select";
import NoRecordFound from "../../../../../components/ui/noRecordFound/NoRecordFound";
const CostAllocation = ({ rows = [], isDisabled = true }) => {
    return (
        <>
            <div className="cost-allocation-list member-list">
                <div className="content-section">
                    <div className="table-section">
                        <table>
                            <thead>
                                <tr>
                                    <th>Cert Number</th>
                                    <th>Item Code</th>
                                </tr>
                            </thead>

                            <tbody>
                                {rows.map((row) => {
                                    return (
                                        <tr key={row.id}>
                                            <td>{row.label}</td>
                                            <td>
                                                <div className="form-group">
                                                    <Select
                                                        className="custom-checkbox-select"
                                                        value={row.value}
                                                        options={row.options}
                                                        placeholder="Select"
                                                        isDisabled={isDisabled}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                                {rows.length === 0 && (
                                    <tr>
                                        <td colSpan={2}><NoRecordFound /></td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CostAllocation;